exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.countdown i {\n  font-style: normal;\n}\n.countdown .labelcolor {\n  color: #258d47;\n  font-size: 14px;\n  margin-right: 5px;\n}\n.countdown .timecolor {\n  color: #f79554;\n  font-size: 14px;\n}\n.countdown .i-color {\n  color: #f79554;\n  font-size: 14px;\n}\n.countdown .endcolor {\n  color: #999999;\n  font-size: 14px;\n}\n.countdown .endcolor span {\n  color: #999999;\n}\n", ""]);

// exports
